import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Statement from "../components/site/Statement";
import Capabilities from "../components/site/Capabilities";
import Portfolio from "../components/site/Portfolio";
import Worries from "../components/site/Worries";
import Process from "../components/site/Process";
import About from "../components/site/About";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function Home() {
    return (
        <div
            data-testid="home-page"
            className="min-h-screen bg-white text-[#1F2A23] overflow-x-hidden"
        >
            <Header />
            <main>
                <Hero />
                <Statement />
                <Capabilities />
                <Portfolio />
                <Worries />
                <Process />
                <About />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
